<!-- Buttons -->
<div class="search-entity-buttons">
  <a
    *ngIf="primaryLink && primaryLink?.displayString && primaryLink?.url"
    class="search-entity-primary-button"
    [attr.href]="getLink(primaryLink.url)"
    [appResultClickTracking]="searchResultEntry"
    englishDisplayString="{{ primaryLink.englishDisplayString }}"
    (click)="triggerSearch(primaryLink.url)"
  >
    {{ primaryLink.displayString }}
  </a>

  <div class="d-flex flex-column" *ngIf="addToCart">
    <a
      class="search-entity-primary-button"
      id="search-entity-purchase-url"
      [appPurchase]="searchResultEntry"
      englishDisplayString="{{ searchResultEntry.purchaseUrl?.englishDisplayString }}"
      [listPrice]="listPrice"
      [currencyCode]="currencyCode"
      [appResultClickTracking]="searchResultEntry"
      hrefHolder="{{ searchResultEntry.purchaseUrl?.url }}"
      (showAddToCartErrorChange)="showAddToCartError = $event"
    >
      {{ searchResultEntry.purchaseUrl?.displayString }}</a
    >
    <div class="search-entity-mashup-add-to-cart-error">
      <span *ngIf="showAddToCartError"> ({{ 'tryAgain' | translate }}) </span>
    </div>
  </div>

  <ng-container *ngFor="let secondaryLink of secondaryLinks">
    <a
      *ngIf="secondaryLink && secondaryLink?.displayString && secondaryLink?.url"
      class="search-entity-secondary-button"
      [attr.href]="getLink(secondaryLink?.url)"
      (click)="triggerSearch(secondaryLink?.url)"
      [appResultClickTracking]="searchResultEntry"
      englishDisplayString="{{ secondaryLink.englishDisplayString }}"
    >
      {{ secondaryLink.displayString }}
    </a>
  </ng-container>

  <a
    *ngIf="isShowContactUs"
    class="search-entity-tertiary-button"
    [href]="searchResultEntry.contactUsUrl?.url"
    [appResultClickTracking]="searchResultEntry"
    englishDisplayString="{{ searchResultEntry.contactUsUrl?.englishDisplayString }}"
    sendSignal="false"
  >
    {{ searchResultEntry.contactUsUrl?.displayString }}
    <svg-icon
      style="margin-left: 0.75rem; position: relative; top: -6px"
      key="chevron-right-new"
      width="6px"
      height="12px"
    ></svg-icon>
  </a>
</div>

<!-- Extra Links -->
<div class="search-entity-extra-links col-lg-8">
  <ng-container *ngFor="let linkEntry of otherLinks">
    <div *ngIf="linkEntry?.url && linkEntry?.displayString">
      <a
        [attr.href]="getLink(linkEntry?.url)"
        (click)="triggerSearch(linkEntry?.url)"
        [appResultClickTracking]="searchResultEntry"
        sendSignal="false"
        englishDisplayString="{{ linkEntry?.englishDisplayString }}"
        >{{ linkEntry?.displayString }}</a
      >
    </div>
  </ng-container>
</div>
